import windIcon from "@/img/strong-wind-icon.svg";
import dustIcon from "@/img/dust-icon.svg";
import fogIcon from "@/img/fog-icon.svg";
import thunderstormIcon from "@/img/thunderstom-icon.svg";
import highWavesIcon from "@/img/high-waves-icon.svg";
import rainfallIcon from "@/img/heavy-rainfall-icon.svg";
import hailIcon from "@/img/hail-icon.svg";
import highTempIcon from "@/img/high-tempature-icon.svg";
import frostIcon from "@/img/frost-icon.svg";

export const MAP_CONTROLS: {
	img: string;
	text: string;
	isActive: boolean;
	value: string;
}[] = [
	{
		img: windIcon,
		text: "strongWind",
		isActive: true,
		value: "Strong wind",
	},
	{
		img: dustIcon,
		text: "dust",
		isActive: true,
		value: "Dust",
	},
	{
		img: fogIcon,
		text: "fog",
		isActive: true,
		value: "Fog",
	},
	{
		img: thunderstormIcon,
		text: "thunderstorm",
		isActive: true,
		value: "Thunderstorm",
	},
	{
		img: highWavesIcon,
		text: "highWaves",
		isActive: true,
		value: "High waves",
	},
	{
		img: rainfallIcon,
		text: "heavyRainfall",
		isActive: true,
		value: "Heavy rainfall",
	},
	{
		img: hailIcon,
		text: "hail",
		isActive: true,
		value: "Hail",
	},
	{
		img: highTempIcon,
		text: "highTemperature",
		isActive: true,
		value: "High temperature",
	},
	{
		img: frostIcon,
		text: "frost",
		isActive: true,
		value: "Frost",
	},
];
